import React, { useEffect, useState } from "react";
import { Col, Row, Select } from "antd";
import { Controller } from "react-hook-form";
import CustomSelect from "../../../../../common/input/custom-select/custom-select";
import styles from "./subject-threshold-fields.module.css";
import { fetchExamTypes, fetchInstituteExams, fetchInstituteSubjects } from "../../../../../services/student_promotion";
import CustomTextfield from "../../../../../common/input/custom-textfield/custom-textfield";

const SubjectThresholdFields = ({ control, watch, setLoading }) => {
  const [examTypes, setExamTypes] = useState([]);
  const [examList, setExamList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const examTypeId = watch("exam_type_id");

  useEffect(() => {
    getExamTypes();
    getInstituteSubjects();
  }, []);

  useEffect(() => {
    if (examTypeId) {
      getInstitutionExams();
    }
  }, [examTypeId]);

  const getExamTypes = async () => {
    try {
      setLoading(true);
      const response = await fetchExamTypes();
      if (response?.data) {
        setExamTypes(response?.data?.data);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const getInstitutionExams = async () => {
    try {
      setLoading(true);
      const payload = { exam_type_id: examTypeId };
      const response = await fetchInstituteExams(payload);
      if (response?.data) {
        setExamList(response?.data?.data);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setExamList([]);
      setLoading(false);
    }
  };

  const getInstituteSubjects = async () => {
    try {
      setLoading(true);
      const response = await fetchInstituteSubjects();
      if (response?.data) {
        setSubjectList(response?.data?.data);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  return (
    <div className={styles.thresholdInputContainer}>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Controller
            name="exam_type_id"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomSelect
                id="exam_type_id"
                label="Select Exam Type"
                showRequired
                labelColor="#667085"
                placeholder="--Select--"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              >
                {examTypes?.map((option) => (
                  <Select.Option
                    key={option?.id}
                    value={option?.id}
                  >
                    {option?.term}
                  </Select.Option>
                ))}
              </CustomSelect>
            )}
          />
        </Col>

        <Col span={12}>
          <Controller
            name="exam_id"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomSelect
                id="exam_id"
                label="Select Exam"
                showRequired
                labelColor="#667085"
                placeholder="--Select--"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              >
                {examList?.map((option) => (
                  <Select.Option
                    key={option?.id}
                    value={option?.id}
                  >
                    {option?.exam_name}
                  </Select.Option>
                ))}
              </CustomSelect>
            )}
          />
        </Col>
      </Row>

      <Controller
        name="subject_id"
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomSelect
            id="subject_id"
            label="Choose Subjects"
            showRequired
            labelColor="#667085"
            placeholder="e.g. Science, Math"
            showSearch
            mode="multiple"
            size="large"
            value={value}
            onChange={onChange}
            status={error ? "error" : ""}
          >
            {subjectList?.map((option) => (
              <Select.Option
                key={option?.id}
                value={option?.id}
              >
                {option?.name}
              </Select.Option>
            ))}
          </CustomSelect>
        )}
      />

      <div>
        <p className={styles.instruction}>
          For distribution please mention the minimum and maximum value.
        </p>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Controller
              name="min_value"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <CustomTextfield
                  id="min_value"
                  label="Min"
                  showRequired
                  labelColor="#434343"
                  placeholder="e.g. 20"
                  size="large"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                />
              )}
            />
          </Col>

          <Col span={12}>
            <Controller
              name="max_value"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <CustomTextfield
                  id="max_value"
                  label="Max"
                  showRequired
                  labelColor="#434343"
                  placeholder="e.g. 70"
                  size="large"
                  value={value}
                  onChange={onChange}
                  status={error ? "error" : ""}
                />
              )}
            />
          </Col>
        </Row>

        <div className={styles.criteriaBox}>
          <p className={styles.criteriaTitle}>
            Based on your input, here is the distribution criteria:
          </p>

          <ul className={styles.criteriaList}>
            <li>Sciences — avg ≥ max</li>
            <li>Commercials — min &lt; avg &lt; max</li>
            <li>Arts — avg ≤ min</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SubjectThresholdFields;